import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { MessageResult } from '../../models/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ActiveToast, ToastrService } from 'ngx-toastr';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class AlertService {

  private subject = new Subject<any>();
  constructor(public snackBar: MatSnackBar, public toastr: ToastrService, public router: Router){}

  confirm(message: string, siFn: () => void, noFn: () => void = () => {}){
    console.log("AlertService.confirm: " + message);
    this.setConfirmation(message, siFn, noFn);
  }

  setConfirmation(message: string, siFn:()=>void, noFn:()=>void = () => {}) {
   let that = this;
   this.subject.next({ type: "confirm",
       text: message,
       siFn:
       function(){
           that.subject.next(null);
           if (siFn) siFn();
           return false;
       },
       noFn:function(){
           that.subject.next(null);
           if (noFn) noFn();
           return false;
       }
   });
 }

 setCrucialConfirmation(message: string,siFn:()=>void,noFn:()=>void) {
   let that = this;
   let randomNumber = Math.round(Math.random() * 10000);
   while (randomNumber<1 || randomNumber>9999) {
     randomNumber = Math.round(Math.random() * 10000);
   }

   this.subject.next({ type: "confirmCrucial",
       text: message,
       randomNumber: randomNumber,
       siFn:
       function(){
           that.subject.next(null);
           siFn();
       },
       noFn:function(){
           that.subject.next(null);
           noFn();
       }
   });
 }

 alertMessageResult(messageResult: MessageResult) {
   if (!messageResult.message) return;
   if (messageResult.message == "") return;

   if ( messageResult.isError || messageResult.message.startsWith("Fehler:")) {
     this.setError(messageResult.message);
   } else if (messageResult.isWarning || messageResult.message.startsWith("Warnung:")) {
     this.setWarning(messageResult.message);
   } else {
     this.setMessage(messageResult.message);
   }
 }

 clearMessage(message: string):string {
  if (message) message = message.replace(/Error:/g, "").trim();
  return message;
 }

 setError(message: string): Observable<void> {
  message = this.clearMessage(message);
  console.error(message);
  return this.toastr.error(message).onShown;
 }

 setWarning(message: string): Observable<void> {
  message = this.clearMessage(message);
  console.warn(message);
  return this.toastr.warning(message).onShown;
 }

 setWarningLongTerm(message: string): Observable<void> {
  message = this.clearMessage(message);
  console.warn(message);
  return this.toastr.warning(message, undefined, {timeOut: 10000}).onShown;
 }

 setMessage(message: string): Observable<void> {
  message = this.clearMessage(message);
  console.info("set message: ",message);
  return this.toastr.info(message).onShown;
 }

 setOk(message: string): Observable<void> {
  message = this.clearMessage(message);
  console.info(message);
  return this.toastr.success(message).onShown;
 }

 startProgress(message: string): ActiveToast<any> {
  message = this.clearMessage(message);
  console.error(message);
  return this.toastr.info(message, undefined, {progressBar: true, progressAnimation: 'increasing'});
 }

 getMessage(): Observable<any> {
    return this.subject.asObservable();
 }

 handleError(error: HttpErrorResponse) {
   if (error.error && error.error instanceof ErrorEvent) {
     // A client-side or network error occurred. Handle it accordingly.
     this.setError(error.error.message);
   }
   else if (error.error && typeof error.error === 'string') {
    // A client-side or network error occurred. Handle it accordingly.
    var errorString = error.error as string;
    this.setError(errorString);
   }
   else if (error.status == 204 ) {
    //no content
   }
   else if (error.status == 401 ) {
    this.setError('Anmeldung ungültig!');
   }
   else if (error.status == 403 ) {
    this.setWarning('Keine Änderungen!');
   }
   else if (error.status == 412 || error.status == 204) {
     this.setWarning(this.ab2str(error.error));
   }
   else if (error.status==0) {
     this.setError('Server-Fehler: Keine Antwort!');
   }
   else if (error.error && error.error.ExceptionMessage) {
     this.setError(error.error.ExceptionMessage);
   }
   else if (error.status && error.statusText) {
     // The backend returned an unsuccessful response code.
     // The response body may contain clues as to what went wrong,
     this.setError(' Fehler: HTTP ' + error.status + ' (' + error.statusText + ')');

     //let body:string = JSON.parse(error['_body']);
     if (error.error) {
       console.error(this.ab2str(error.error));
     }
   }
   else if (error.message ) {
    this.setError(error.message);
   }
   else {
    // The backend returned an unsuccessful response code.
    // The response body may contain clues as to what went wrong,
    this.setError('Undefinierter Fehler');

    if (error.error) {
      console.error(this.ab2str(error.error));
    }
  }

 }

 logout() {
    let self = this;
    setTimeout(()=>{ self.router.navigateByUrl("/logout");}, 1000);
 }

ab2str(buf: ArrayBuffer | Uint8Array): string {
  let uint8Array: Uint8Array;
  if (buf instanceof Uint8Array) {
    uint8Array = buf;
  } else {
    uint8Array = new Uint8Array(buf);
  }
  return String.fromCharCode(...uint8Array);
}
}


